import { object, number } from "yup";

export const SystemConnectionsValidationSchema = object({
  systemId: number().notOneOf([0]).required("Задолжително"),
  internalSystemUserId: number().notOneOf([0]).required("Задолжително"),
  externalSystemUserId: number().notOneOf([0]).required("Задолжително"),
});
